export const SIGN_UP_STATE = "SIGN_UP_STATE";

const newUserSignUp = () => {
}

export default newUserSignUp;
